import { render, staticRenderFns } from "./Pagamento-empresa.vue?vue&type=template&id=b434fec4&"
import script from "./Pagamento-empresa.vue?vue&type=script&lang=js&"
export * from "./Pagamento-empresa.vue?vue&type=script&lang=js&"
import style0 from "./Pagamento-empresa.vue?vue&type=style&index=0&id=b434fec4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports